export class OdometerLogTrailModel {
    public odometerLogTrialId: number;
    public odometerLogTrailHashId: string;
    public vehicleMasterHashId: string = '';
    public userProvidedOdometerValueInKm: string;
    public userUpdatedDateTime: string = '';
    public personName: string;
    public descriptionOfDeviation: string = 'GPS correction';
    public licenceTag: string;
    public companyName: string;
    public isChecked: boolean;
    public listOfOdometerLogTrailHashId: string[] = [];
    public deviation: number;
    public isPersonDeleted: boolean;
    public personMasterHashId: string;
    public instanceName: string;
    public calculateOdometerValue: string;
    public lastOdometerDateTime: string;
    public isEditable:boolean;
    public isDeletable:boolean;
    public isRegisterBy:boolean;
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/odometerlogtrail/models/odometerlogtrail.model.ts